import { render, staticRenderFns } from "./MobileBasket.vue?vue&type=template&id=b2368396&scoped=true&"
import script from "./MobileBasket.vue?vue&type=script&lang=js&"
export * from "./MobileBasket.vue?vue&type=script&lang=js&"
import style0 from "./MobileBasket.vue?vue&type=style&index=0&id=b2368396&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2368396",
  null
  
)

export default component.exports